var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.successMessage)?_c('v-alert',{attrs:{"dense":"","text":"","type":"success"}},[_vm._v(" "+_vm._s(_vm.successMessage)+" ")]):(_vm.errorMessage)?_c('v-alert',{attrs:{"dense":"","text":"","type":"error"}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }